import React, { useEffect, useState, useRef } from 'react'
import MainLayout from '../../containers/MainLayout'
import Loader from '../../baseComponents/Loader'
import PageTitle from '../../baseComponents/PageTitle'
import { Fade } from 'react-slideshow-image'
import arrow from '../../assets/images/svg_icons/arrow.svg'
import { getOperationsInfo } from '../../services/operations'
import { connect } from 'react-redux'
import { langTexts } from './locals'

import titleLogo from '../../assets/images/title-icons/Portfolio-Line.svg'
import { ReactComponent as Logo } from '../../assets/images/title-icons/Portfolio-Line.svg'
import pharmaIcon from '../../assets/images/title-icons/Pharma-Line.svg'
import chickenIcon from '../../assets/images/title-icons/Chicken-Line.svg'
import DNAIcon from '../../assets/images/title-icons/DNA-Line.svg'

import 'react-slideshow-image/dist/styles.css'
import './index.css'

const Operations = props => {
  const { lang } = props.settings
    , texts = langTexts[lang]

  const [isFetching, setIsFetching] = useState(true)
    , [activeClass, setActiveClass] = useState('')
    , [currentSlide, setCurrentSlide] = useState(0)
    , [data, setData] = useState({})
    , slideRef = useRef(null)

  useEffect(() => {
    let timeout = null
    getOperationsInfo()
      .then(res => {
        setData(res)
        console.log('Ress', res)
        setIsFetching(false)
        timeout = setTimeout(() => {
          setActiveClass('active')
        }, 800)
      })
      .catch(err => console.log(err))

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  if (isFetching) return <Loader />


  const onChangeSlide = (previous, next) => {
    setCurrentSlide(next)
  }

  let info = data[lang]

  let title = data[lang].title ? data[lang].title : texts.title
    , label = data[lang].titleRedLabel ? data[lang].titleRedLabel : ''

  const zoomInProperties = {
    autoplay: info.gallery.length > 1,
    indicators: false,
    arrows: false,
    scale: 1.4
  }

  return <MainLayout id='operations' className={`${activeClass} transition`} logo={<Logo />}>
    <div className='operations__container'>
      <div className='operations__main-content'>
        <div>
          <div className='operations__side-content'>
            <div className='gray-line' />
            <PageTitle title={title} label={label} logo={titleLogo} />
          </div>
          <div className='operations__quote'>
            <div className='gray-line' />
            <div className='operations__quote-title'>
              <div dangerouslySetInnerHTML={{ __html: info.quote }} />
            </div>
          </div>
          <div className='operations__text-content title-block'>
            <div className='operations__main-content-header'>
              <img src={pharmaIcon} className='title-logo transition' alt='search' />
              <div className='gray-line' />
            </div>
            <h3>{info.pharma.title}</h3>
          </div>
          <div className='operations__text-content' dangerouslySetInnerHTML={{ __html: info.pharma.paragraphs }} />
        </div>
      </div>
      <div className='operations__slider transition pharma-slider'>
        <div className='operations__slider-container'>
          <Fade ref={slideRef} {...zoomInProperties} onChange={onChangeSlide}>
            {
              info.gallery.map((item, index) => (
                <div key={index} className='operations__slider-image' style={{ background: `url(${item.image})` }}>
                </div>
              ))
            }
          </Fade>
        </div>
        <div className='operations__slider-bullets-container'>
          {
            info.gallery > 1 &&
            info.gallery.map((item, index) => <div
              key={index}
              className={`bullet ${currentSlide === index ? 'current' : ''} transition`}
              onClick={() => {
                setCurrentSlide(index)
                slideRef.current.goTo(index)
              }}
            />)
          }
        </div>
      </div>
    </div>

    <div className='operations__container  animals-section'>
      <div className='operations__slider transition'>
        <div className='operations__slider-container'>
          <img src={info.animal.cover} alt='cover' className='operations-small-cover' />
        </div>
      </div>
      <div className='operations__main-content'>
        <div>
          <div className='operations__main-content-header'>
            <img src={chickenIcon} className='title-logo transition' alt='search' />
            <div className='gray-line' />
          </div>
          <h3>{info.animal.title}</h3>
          <div className='operations__text-content' dangerouslySetInnerHTML={{ __html: info.animal.paragraphs }} />
        </div>
        <a href={info.animal.web.link} target='_blank' rel='noreferrer'>{info.animal.web.title} <img className='arrow-left' src={arrow} alt='flecha' /></a>
      </div>
    </div>
    <div className='operations__container  animals-section'>
      <div className='operations__slider transition'>
        <div className='operations__slider-container'>
          <img src={info.aviar.cover} alt='cover' className='operations-small-cover' />
        </div>
      </div>
      <div className='operations__main-content'>
        <div>
          <div className='operations__main-content-header'>
            <img src={DNAIcon} className='title-logo transition' alt='search' />
            <div className='gray-line' />
          </div>
          <h3>{info.aviar.title}</h3>
          <div className='operations__text-content' dangerouslySetInnerHTML={{ __html: info.aviar.paragraphs }} />
        </div>
        <a href={info.aviar.web.link} target='_blank' rel='noreferrer'>{info.aviar.web.title} <img className='arrow-left' src={arrow} alt='flecha' /></a>
      </div>
    </div>
    <div className='operations__side-content values'>
      <div className='gray-line' />
      <PageTitle title={info.values.title} label='' logo={titleLogo} />
    </div>
    <div className='about-us__values transition'>
      {
        info.values.items.map((item, index) => {
          return <div key={index} className='about-us__values-item'>
            <img src={item.icon} alt={item.name} />
            <div>
              <h3>{item.name}</h3>
              <div className='about-us__values-item-text' dangerouslySetInnerHTML={{ __html: item.text }} />
            </div>
          </div>
        })
      }
    </div>
  </MainLayout>
}

const mapStateToProps = state => ({
  settings: state.settings
})

export default connect(mapStateToProps)(Operations)

